<template>
  <div :class="`mdn-Input ${ !value || 'mdn-Input--activatedField'}`">
    <input
      :class="`mdn-Input-field ${ error ? 'is-invalid' : ''}`"
      :name="name"
      type="time"
      v-model="value"
      @change="updateValue"
      :aria-invalid="!!error"
      :disabled="disabled"
      :readonly="readOnly"
      :ref="name"
    >
    <label for="date" class="mdn-Input-label">{{ placeholder }}</label>
    <small class="mdn-Input-errorFeedback">Por favor, preencha este campo corretamente.</small>
  </div>
</template>

<script>
export default {
  name: "SGPFormHoraComponent",

  props: {
    placeholder: {
      type: String,
      required: false,
      default: "Hora"
    },
    
    name: {
      type: String,
      required: true,
    },

    parse: {
      type: Boolean,
      required: false,
      default: true,
    },

    value: {
      type: [String, Number],
      required: true,
      default: ''
    },

    readOnly: {
      type: Boolean,
      required: false,
      default: false
    },

    disabled: {
      type: Boolean,
      required: false,
      default: false
    },

    error: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  methods: {
    updateValue () {
      this.$emit('input', this.value)
      this.$emit('change', this.value)
    }
  }

  
}
</script>

<style scoped>
.mdn-Input-label {
  min-width: 40px;
  background-color: #fff;
}
</style>